import {ActionStatusType, ActionType, UrgencyType} from '../enums/enums';

export class AddActionsRequest {
  constructor (
    public type: ActionType,
    public status: ActionStatusType,
    public urgency: UrgencyType,
    public instructions: string,
    public dueDate: string,
    public interventionTeamId: string,
    public issueGuids: string[],
    public priority: number,
    public reference?: string,
    public workOrderReference?: string,
  ) { }
}
